import pb from './pocketbase';

const PUBLIC_VAPID_KEY = 'BIqRrZJI_VdHSjIFTNiSJAKqyFWlnKUA_xJhYFBuGzDmDjYqdSBbSWNumMByqEiV_aWPn60STIsd6hAeY1PW'; 

export const pushNotificationService = {
  /**
   * Demande la permission et enregistre l'abonnement push dans PocketBase
   */
  async subscribeUser() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push notifications not supported');
      return;
    }

    try {
      const registration = await navigator.serviceWorker.ready;
      
      // Récupérer l'abonnement existant
      let subscription = await registration.pushManager.getSubscription();
      
      // Si pas d'abonnement, en créer un nouveau
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
        });
      }

      // Envoyer l'abonnement à PocketBase
      const user = pb.authStore.model;
      if (user) {
        // Vérifier si cet abonnement existe déjà pour cet utilisateur
        const subJson = JSON.stringify(subscription);
        const existing = await pb.collection('push_subscriptions').getList(1, 1, {
          filter: `user = "${user.id}" && subscription = "${subJson.replace(/"/g, '\\"')}"`
        });

        if (existing.items.length === 0) {
          await pb.collection('push_subscriptions').create({
            user: user.id,
            subscription: subJson
          });
          console.log('Push subscription saved to PocketBase');
        }
      }
    } catch (error) {
      console.error('Failed to subscribe to push notifications:', error);
    }
  },

  /**
   * Helper pour convertir la clé VAPID
   */
  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
};
